import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Typography,
} from "@material-tailwind/react";
import { Form, Formik } from "formik";
import FormikInput from "components/form/formik-input";
import FormikTextarea from "components/form/formik-textarea";
export default function CreateSurveyDialog({
    show,
    setShow,
    initialValues,
    handleSubmit,
    validationSchema,
}) {
    const handleClose = () => {
        setShow((prev) => !prev);
    };
    return (
        <Dialog
            open={show}
            handler={handleClose}
            className="dialog"
        >
            <DialogHeader className="dialog__header">
                <Typography variant="h2">Create A New Survey</Typography>
            </DialogHeader>

            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
            >
                {({ isValid, dirty }) => (
                    <Form>
                        <DialogBody className="dialog__body">
                            <div className="dialog__section">
                                <FormikInput
                                    className="font-body"
                                    name="name"
                                    type="text"
                                    label="Survey Title (respondents will see this text)"
                                    required
                                />
                            </div>

                            <div className="dialog__section">
                                <FormikTextarea
                                    name="description"
                                    className="text-lg font-body text-primary-text"
                                    label="Survey Description (for your reference only)"
                                />
                            </div>
                        </DialogBody>

                        <DialogFooter className="dialog__footer">
                            <Button
                                type="button"
                                className="btn btn--secondary"
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                className="btn btn--primary"
                                disabled={!(isValid && dirty)}
                            >
                                Create
                            </Button>
                        </DialogFooter>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
